// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nn-c";
export var backButton = "_nn-4";
export var backIcon = "_nn-5";
export var chevronShortcut = "_nn-6";
export var container = "_nn-1";
export var editor = "_nn-8";
export var editorWrapper = "_nn-7";
export var prefix = "_nn-2";
export var searchIcon = "_nn-3";
export var suffix = "_nn-9";
export var suffixContent = "_nn-a";
export var suffixText = "_nn-b";
export var wrapper = "_nn-0";